module.exports = __webpack_public_path__ + "img/twitter.15e17b9c.svg";